import React from "react";

function Header() {

  return (

    <div className="header">

      <div>

        <h1>Movie Explorer</h1>

        <p>
          Search, filter, and favorite movies.
          Designed for a single-page React component structure.
        </p>

      </div>

      <span>
        Local data • React state ready
      </span>

    </div>
  );
}

export default Header;